<template>
    <div class="carmap">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 22px 0 20px 26px; ">
            <el-breadcrumb-item>车辆轨迹</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="map-title">
            <div>
                <span>车牌号</span>
                <input type="text" placeholder="请输入车牌" v-model="inpval" class="inp">
            </div>
            <div>
                <span>开始时间</span>
                <el-date-picker v-model="startTime" type="datetime" format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间">
                </el-date-picker>
            </div>
            <div>
                <span>结束时间</span>
                <el-date-picker v-model="endTime" type="datetime" format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间">
                </el-date-picker>
            </div>
            <button class="search" @click="getmapinfo">搜索</button>
            <button class="search" @click="getguijidlg">轨迹回放</button>
        </div>
        <div id="container"></div>
        <!-- <guijihuifang :guijidialog="guijidialog" @closeDlog="closeDlog"/> -->
    </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
// import guijihuifang from './components/guijihuifang';
import coordtransform from 'coordtransform'
import dayjs from 'dayjs';
window._AMapSecurityConfig = {
    securityJsCode: "78359427ec75b294d1085b283c76a9d7"
};
const MAP_PLUGINS = [
    "AMap.Scale",
    "AMap.ToolBar",
    "AMap.ControlBar",
    "AMap.HawkEye",
    "AMap.Driving",
    "AMap.DrivingRender"
]
export default {

    data() {
        return {
            inpval: "",
            map: null,
            lat: 38.969557,
            lng: 117.769324,
            searchinfo: {},
            cheliangweizhi: null,
            startTime: dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            endTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            trackPoints: [],
            guijidialog: false,
            pno:""
        }
    },
    components: {
        // guijihuifang
    },
    created() {
        this.inpval = this.$route.query.plate;
        this.gmtCreate=this.$route.query.gmtCreate
        this.gmtModified=this.$route.query.gmtModified
        this.pno=this.$route.query.pno
        this.startTime=this.gmtCreate?this.gmtCreate:dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.endTime=this.gmtModified?this.gmtModified:dayjs().format('YYYY-MM-DD HH:mm:ss')

    },
    mounted() {
        // this.initMap(true)
        this.getmapinfo();
        // this.initAMap(false)
    },
    methods: {
        getguijidlg() {
            // this.guijidialog=true
            this.$router.push({
                path: "/member/guijihuifang",
                query: {
                    plate: this.inpval,
                    startTime:this.startTime,
                    endTime:this.endTime,
                    pno:this.pno
                }
            })
        },
        // closeDlog(e){
        //     this.guijidialog=false
        // },
        async getmapinfo() {
            this.trackPoints = []
            const { data: res } = await this.$http(
                "api1",
                "/api/replenish/station/carMapLineV3",
                "post",
                {
                    plate: this.inpval,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    pno:this.pno?this.pno:''
                }
            )
            if (!res.data||res.data.length == 0) {
                this.initMap(false)
                return this.$message("未查询到当前车辆的轨迹信息")

            }
            if (res.belongCarFactory == '吉利') {
                res.data.forEach(item => {
                    let arr = [item.lon, item.lat]
                    // this.trackPoints.push(coordtransform.wgs84togcj02(item.lon,item.lat))
                    // this.trackPoints.push(coordtransform.bd09togcj02(item.lon,item.lat))
                    // this.trackPoints.push(coordtransform.gcj02towgs84(item.lon,item.lat))
                    // this.trackPoints.push(coordtransform.gcj02tobd09(item.lon,item.lat))
                    this.trackPoints.push(arr)
                    // console.log(this.trackPoints);bd09togcj02 gcj02towgs84 gcj02tobd09
                })
            } else {
                res.data.forEach(item => {
                    // axios.get(
                    //     `https://restapi.amap.com/v3/assistant/coordinate/convert?key=a03996cfbfb168621ad6a266e08b74e7&locations=${item.lon},${item.lat}&coordsys=gps`,

                    // ).then(res=>{
                    //     let arr=res.data.locations.split(",")
                    //     this.trackPoints.push(arr)
                    //     // console.log(this.trackPoints);
                    // })
                    this.trackPoints.push(coordtransform.wgs84togcj02(item.lon, item.lat))

                })
            }

            this.initMap()
            setTimeout(() => {
                this.drawTrajectory();
            }, 1000)
        },

        initMap() {
            // 高德地图API的key需要你自己的，这里请替换成你的
            const key = 'e1e067886b395ac1aa709c2dd9982e7a';
            const url = `https://webapi.amap.com/maps?v=1.4.15&key=${key}&callback=initAMap`;
            // 动态创建script标签加载高德地图API
            const script = document.createElement('script');
            script.setAttribute('async', '');
            script.setAttribute('src', url);
            document.body.appendChild(script);

            // 初始化地图的回调函数
            window.initAMap = () => {
                this.map = new AMap.Map('container', {
                    zoom: 14,
                    center: [117.769324, 38.969557], // 初始化地图中心点
                });
            };

        },
        drawTrajectory() {
            const _this = this
            // _this.trackPoints=[]
            // let route=[{path:_this.trackPoints.slice(0,1000),color:'red',},{path:_this.trackPoints.slice(1000,2000),color:'green',},{path:_this.trackPoints.slice(2000),color:'blue',}]
            const polyline = new AMap.Polyline({
                path: _this.trackPoints,
                borderWeight: 2, // 线条宽度
                strokeColor: 'green', // 线条颜色
            });
            polyline.setMap(this.map);
            console.log(polyline.getPath()[0]);
            var startMarker = new AMap.Marker({
                position: polyline.getPath()[0], // 起始点的经纬度
                icon: require('/public/homeImg/qd_icon.png'),
                offset: new AMap.Pixel(-10, -10), // 图标偏移量，使图标指向起始点
            });
            var endMarker = new AMap.Marker({
                position: polyline.getPath()[polyline.getPath().length-1], // 起始点的经纬度
                icon: require('/public/homeImg/zd_icon.png'),
                offset: new AMap.Pixel(-10, -10), // 图标偏移量，使图标指向起始点
            });
            endMarker.setMap(this.map)
            startMarker.setMap(this.map);
        },
    },
}
</script>

<style lang="scss" scoped>
.carmap {
    width: 100%;
    height: calc(100vh - 88px);
    overflow: hidden;
    position: relative;

    .map-title {
        position: absolute;
        top: 80px;
        left: 30px;
        padding: 10px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background-color: #fff;
        z-index: 33;

        .inp {
            padding: 10px;
            border: none;
            outline: none;
            background-color: #F8F9FB;
        }

        .search {
            margin-left: 20px;
            width: 80px;
            height: 30px;
            background: #17B6A1;
            border-radius: 8px;
            font-size: 80%;
            font-family: PingFang SC;
            font-weight: 400;
            color: #fff;
            text-align: center;
            // line-height: 32px;
            border: none;
        }
    }

    #container {
        height: 100%;
    }
}
</style>